const $inject = ['ENUMS'];

const ancillaryServicesAmountsFilter = (ENUMS) => {
  return (ancillaryServices) => {
    return _.filter(ancillaryServices, (service) => {
      return service.QuantitySelected > 0 && !_.findKey(ENUMS.railSeatPreferenceTypes, (preferenceType) => {
          return preferenceType === service.Type;
        });
    });
  }
};

ancillaryServicesAmountsFilter.$inject = $inject;

export default ancillaryServicesAmountsFilter;



// WEBPACK FOOTER //
// ./src/filters/ancillaryServicesAmountsFilter.js